export const MOBILE_STICKY_HEIGHT = 54
export const TABLET_STICKY_HEIGHT = 94

export const constants = { MOBILE_STICKY_HEIGHT, TABLET_STICKY_HEIGHT }
export default constants
